import styled from 'styled-components';
import { Box, Layout, Stack, ShortText, pxToRem } from 'src/viewLayer/components/DesignSystem';
import type { BabbelTheme } from '@lessonnine/design-tokens.lib/dist/json/theme';

import devices from 'src/viewLayer/styling/mixins/media-queries';

export const EmailConfirmationWrapper = styled(Layout)`
  background-color: 'transparent';
  margin: 0 0 2rem;
  min-height: 43rem;
  text-align: center;

  @media ${devices.fromxsmall} {
    margin: 2.35rem 0 2rem;
    min-height: 37rem;
  }

  @media ${devices.fromsmall} {
    width: 75%;
  }
`;

export const MainImageWrapper = styled(Box)`
  width: 7.53rem;
  
  @media ${devices.fromxxsmall} {
    width: 11.375rem;
  }
`;

export const ContentStack = styled(Stack)`
  color:  ${({ theme }: {theme: BabbelTheme}): string =>
    theme.color.reference.grey.grey99};
  justify-content: space-between;
  margin-bottom: 1rem;
  padding: 0 2rem;
`;

export const MaintenanceText = styled(ShortText)`
  margin-top: ${pxToRem(20)};
  padding: 0.5rem;

  @media ${devices.fromxsmall} {
    width: 95%;
  }

  @media ${devices.fromsmall} {
    width: 85%;
  }
`;
